module.exports = __webpack_public_path__ + "media/images/pic/hero/waves-55a3721652d38c33e9397455f557a400.png";